import styled from '@emotion/styled';
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { __permissionsObj, __snackBarSeverity, __snackBarText } from '../../constants';
import mainContext from '../../contexts/mainContext';
import { addPromoCode, getCountryCitiesListing, promoCodeLisiting, removePromoCode } from '../../Controllers/ScopeManagement';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import moment from 'moment';
import { Delete, Edit } from '@mui/icons-material';

function FormDialog({ open, handleClose, handleAddUpdate, data }) {
  const { setSnackBar, setPageload } = React.useContext(mainContext);
  const [state, setState] = React.useState({
    country: [],
    applicableCity: data?.applicableCity || [],
    countryId: data?.countryId,
    status: data?.status || "Active",
    expiredAt: data?.expiredAt ? moment(data.expiredAt).format("YYYY-MM-DD") : "",
    maxNoOfUses: data?.maxNoOfUses || 0,
    promoCode: data?.code || "",
    discount: data?.discount,
    discountType: data?.amount || "Amount",
    _id: data._id || null
  })

  React.useEffect(() => {
    async function getCountry() {
      const res = await getCountryCitiesListing()
      if (res.data.status === 200) {
        setState({ ...state, country: res.data.data })
      }
    }
    getCountry()
  }, [])


  const onUpdate = async (stateData) => {
    if (!stateData.promoCode) {
      return setSnackBar({
        status: true,
        text: "Please enter promo code.",
        severity: __snackBarSeverity.warning
      })
    }
    else if (!stateData.countryId) {
      return setSnackBar({
        status: true,
        text: "Please select country.",
        severity: __snackBarSeverity.warning
      })
    }
    else if (stateData.applicableCity.length === 0) {
      return setSnackBar({
        status: true,
        text: "Please select atleast one city.",
        severity: __snackBarSeverity.warning
      })
    }
    else if (!stateData.discountType) {
      return setSnackBar({
        status: true,
        text: "Please select discount type.",
        severity: __snackBarSeverity.warning
      })
    }
    else if (!stateData.discount) {
      return setSnackBar({
        status: true,
        text: "Please enter discount.",
        severity: __snackBarSeverity.warning
      })
    }
    setPageload(true)
    handleAddUpdate(stateData)
  }

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Promocode</DialogTitle>
        <DialogContent style={{ minWidth: '450px' }}>
          <TextField
            autoFocus
            defaultValue={state.promoCode}
            style={{ margin: '10px 0px 10px 0' }}
            margin="dense"
            id="promocode"
            label="Type promo code"
            type="text"
            inputProps={{ maxlength: 20 }}
            fullWidth
            variant="outlined"
            onChange={(e) => { setState({ ...state, promoCode: e.target.value }) }}
          />
          <FormControl fullWidth style={{ margin: '10px 20px 10px 0' }}>
            <InputLabel id='status'>Status</InputLabel>
            <Select
              multiline
              defaultValue={state.status}
              onChange={(e) => { setState({ ...state, status: e.target.value }) }}
              id='status'
              label="status">
              <MenuItem value={"Active"} >Active</MenuItem>
              <MenuItem value={"Inactive"} >Inactive</MenuItem>
            </Select>
          </FormControl>

          <FlexBox>
            <FormControl fullWidth style={{ margin: '10px 20px 10px 0' }}>
              <InputLabel id='country'>Country</InputLabel>
              {state?.country?.length !== 0 && <Select
                defaultValue={state.countryId}
                onChange={(e) => { setState({ ...state, countryId: e.target.value }) }}
                id='country' label="country"
                placeholder='Select country'>
                {state?.country?.map((data) => <MenuItem value={data.country._id}>{data.country.name}</MenuItem>)}
              </Select>}
            </FormControl>
            <FormControl fullWidth style={{ margin: '10px 0px 10px 0' }}>
              <InputLabel id='city'>City</InputLabel>
              <Select
                multiple
                defaultValue={state.applicableCity}
                onChange={(e) => { setState({ ...state, applicableCity: e.target.value }) }}
                id='city'
                label="city"
                placeholder='Select city'>
                {state?.country?.map((data) => {
                  if (data.country._id === state.countryId) {
                    return data.city.map((data) => <MenuItem value={data.name} >{data.name}</MenuItem>)
                  }
                })}
              </Select>
            </FormControl>
          </FlexBox>

          <FlexBox>
            <FormControl fullWidth style={{ margin: '10px 20px 10px 0' }}>
              <InputLabel id='dicountType'>Discount type</InputLabel>
              <Select
                multiline
                defaultValue={state.discountType}
                onChange={(e) => { setState({ ...state, discountType: e.target.value }) }}
                id='dicountType'
                label="Dicount type">
                <MenuItem value={"Percentage"}>Percentage</MenuItem>
                <MenuItem value={"Amount"}>Value</MenuItem>
              </Select>
            </FormControl>
            <TextField
              style={{ margin: '10px 0px 10px 0' }}
              value={state?.discount?.toString().substring(0, 2)}
              margin="dense"
              id="discount"
              label="Discount"
              type="text"
              fullWidth
              variant="outlined"
              onChange={(e) => {
                const reg = new RegExp(/^[0-9]*$/gi)
                const res = reg.test(e.target.value.replace(/\n/g, " "));
                if (res) {
                  setState({ ...state, discount: e.target.value })
                }
              }}
            />
          </FlexBox>

          <FlexBox>
            <TextField
              style={{ margin: '10px 10px 10px 0' }}
              defaultValue={state.expiredAt}
              margin="dense"
              id="expiredAt"
              label="Expiry Date"
              type="date"
              fullWidth
              variant="outlined"
              inputProps={{ min: moment(new Date()).format("YYYY-MM-DD") }}
              onChange={(e) => { setState({ ...state, expiredAt: e.target.value }) }}
            />

            <TextField
              value={state?.maxNoOfUses?.toString().substring(0, 3)}
              margin="dense"
              id="maxNoOfUses"
              label="Max usage"
              type="number"
              fullWidth
              variant="outlined"
              onChange={(e) => {
                const reg = new RegExp(/^[0-9]*$/gi)
                const res = reg.test(e.target.value.replace(/\n/g, " "));
                if (res) {
                  setState({ ...state, maxNoOfUses: e.target.value })
                }
              }}
            />
          </FlexBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} size="small" >Cancel</Button>
          <Button onClick={() => onUpdate(state)} variant="contained" size="small" >Update</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}


export default function Promocode() {
  const { setSnackBar, setProfileNavTitle, setPageload } = React.useContext(mainContext);
  const [promoCode, setPromoCode] = React.useState([]);
  const [state, setState] = useState({ openMenu: false, data: {} })

  React.useEffect(() => {
    setProfileNavTitle("Promo codes");
    getPromocode()
    // eslint-disable-next-line
  }, [])

  const handleAdd = async (stateData) => {
    delete stateData.country
    if (!stateData._id) { /* Update promocode */
      delete stateData._id
    }

    const res = await addPromoCode(stateData)
    setPageload(false)
    if (res.data.status === 200) {
      if (stateData._id) { /* Update promo code */
        let index = promoCode.findIndex((data => data._id == stateData._id))
        promoCode[index] = res.data.data
        setPromoCode(promoCode)
      } else { /* Add promo code */
        let promo = promoCode
        promo.push(res.data.data)
        setPromoCode(promo)
      }
      setState({ ...state, openMenu: false, data: {} })
      setSnackBar({
        status: true,
        text: res.data.message,
        severity: __snackBarSeverity.success
      });
    } else {
      setState({ ...state, openMenu: false, data: {} })
      setSnackBar({
        status: true,
        text: res.data.errors[0].message,
        severity: __snackBarSeverity.error
      });
    }
  }

  const getPromocode = async () => {
    setPageload(true)
    const res = await promoCodeLisiting()
    setPageload(false)
    /* Handle response */
    if (res.data.status === 200) {
      setPromoCode(res.data.data)
    } else {
      setSnackBar({
        status: true,
        text: res.data.message,
        severity: __snackBarSeverity.error
      });
    }

  }

  const handleDelete = async (id, index) => {
    let confirm = window.confirm("Do you want to remove promocode.")
    if (!confirm) {
      return
    }
    setPageload(true)
    const res = await removePromoCode(id);
    setPageload(false)
    if (res.data.status === 200) {
      promoCode.splice(index, 1)
      setPromoCode(promoCode)
      setSnackBar({
        status: true,
        text: res.data.message,
        severity: __snackBarSeverity.success
      });
    } else {
      setSnackBar({
        status: true,
        text: res.data.message,
        severity: __snackBarSeverity.error
      });
    }
  }

  return (
    <Conatiner>
      {state.openMenu && <FormDialog data={state.data} open={state.openMenu} handleClose={() => setState({ ...state, openMenu: false, data: {} })} handleAddUpdate={handleAdd} />}
      <Header>
        <Button variant="contained" size='small' onClick={() => setState({ ...state, openMenu: true, data: {} })}>Add Promocode</Button>
      </Header>
      <Body>
        <List>
          <div className="header">Status</div>
          <div className="header">City</div>
          <div className="header">Promo code</div>
          <div className="header">Type</div>
          <div className="header">Discount</div>
          <div className="header">Max usage</div>
          <div className="header">Used</div>
          <div className="header">Expire on</div>
          <div className="header"></div>
        </List>
        <Divider className='divider-gap' />
        {
          promoCode?.map((result, index) =>
            <List key={result._id}>
              <div>
                <div className={`list_card_status pointer ${result.status === "Active" ? "status_active" : result.status === "Inactive" ? "status_inactive" : "status_pending"} `}>{result.status}</div>
              </div>
              <div>
                {result.applicableCity.join(", ")}
              </div>
              <div>
                {result.code}
              </div>
              <div>
                {result.discountType}
              </div>
              <div>
                {result.discount}
              </div>

              <div>
                {result.maxNoOfUses}
              </div>
              <div>
                0
              </div>
              <div>
                {moment(result.expiredAt).format("MMM DD, YYYY")}
              </div>
              <div style={{ display: 'flex' }}>
                <Edit className='pointer' sx={{ marginRight: 2 }} onClick={() => { setState({ ...state, data: result, openMenu: true }) }} />
                <Delete className='pointer' onClick={() => handleDelete(result._id, index)} />

              </div>
            </List>)
        }

        {promoCode.length === 0 && <div className='no-record'><span>No Record Found</span></div>}
      </Body>
    </Conatiner>
  )
}


/* Promocode Css */
const Conatiner = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
`;

const Header = styled("div")`
  button{
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  height: 80vh;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  margin-top: 1rem;
  display: grid;
  grid-template-columns: minmax(0,1.2fr) minmax(0,2fr) minmax(0,1.5fr) minmax(0,1.8fr)  minmax(0,1.5fr) minmax(0,1.5fr) minmax(0,1fr) minmax(0,1.6fr) minmax(0,1fr);
`;

const FlexBox = styled("div")`
display:flex;

`
